import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow",
        outline: "text-foreground",
        brand:
          "border-primary/30 bg-primary/10 text-primary",
        "brand-green":
          "border-secondary/30 bg-secondary/10 text-secondary",
        "brand-accent":
          "border-accent/30 bg-accent/10 text-accent",
        subtle:
          "border-border/50 bg-muted/50 text-muted-foreground",
        number:
          "border-primary/20 bg-primary/5 text-primary font-heading font-semibold tabular-nums",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
